import clsx from 'clsx';
import React from 'react';

import imgRectangleLeft from 'images/pro/rectangle-left.svg';
import imgRectangleRight from 'images/pro/rectangle-right.svg';

import useCurrentUser from '../../hooks/useCurrentUser';
import { subscribe_promotion_path, upgrade_subscription_path } from '../../routes';

const PRO_OFFER_CODE = 'pro-disc25';
const YEARLY_OFFER_CODE = 'yearly';
const MONTHLY_OFFER_CODE = 'monthly';
const YP_OFFER_CODE = 'yp199';

const ProFooterCallout = () => {
  const { currentUser } = useCurrentUser();
  const isCurrentUserSubscriber = currentUser?.is_subscriber;
  const isCurrentUserProSubscriber = currentUser?.is_pro_subscriber;

  return (
    <div className="bg-pink px-16 xs:px-48 py-40 text-center relative">
      <div className="relative z-1">
        <p className="text-overline font-meta-bold text-red-dark uppercase m-0">
          {isCurrentUserSubscriber && !isCurrentUserProSubscriber
            ? 'Upgrade now'
            : !isCurrentUserSubscriber && 'Subscribe'}
        </p>
        <p className="font-meta-serif-medium text-headline-pro-sm text-black m-0 mt-8 md:mt-16">
          The Information Pro.
          <br />
          Don{'’'}t take a meeting without it.
        </p>
        {!isCurrentUserProSubscriber && (
          <a
            href={
              isCurrentUserSubscriber
                ? upgrade_subscription_path()
                : subscribe_promotion_path({
                    offer: `${PRO_OFFER_CODE},${YEARLY_OFFER_CODE},${MONTHLY_OFFER_CODE},${YP_OFFER_CODE}`,
                  })
            }
            className={clsx(
              'text-button font-meta-medium !text-true-white bg-red-dark uppercase',
              'xs:w-245 h-40 flex items-center justify-center rounded-r-2 mx-auto mt-16 md:mt-32',
              'hover:bg-red focus:bg-red transition-colors'
            )}
          >
            {isCurrentUserSubscriber ? 'Go Pro' : 'Get Started'}
          </a>
        )}
      </div>
      <div className="tw-absolute -top-1 left-0 w-133 xs:w-200 sm:w-300 md:w-416">
        <img className="block object-contain object-top w-full" src={imgRectangleLeft} alt="" />
      </div>
      <div className="tw-absolute -bottom-1 right-0 w-133 xs:w-200 sm:w-300 md:w-416">
        <img className="block object-contain object-top w-full" src={imgRectangleRight} alt="" />
      </div>
    </div>
  );
};

export default ProFooterCallout;
